module.exports = __webpack_public_path__ + "img/logo_award.18078172.png";